import React, { useState } from "react";

function Form() {
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    phone: "",
    position: "",
    // 10th & 12th
    tenthBoard: "",
    tenthYear: "",
    tenthPercentage: "",
    twelfthBoard: "",
    twelfthYear: "",
    twelfthPercentage: "",
    // Graduation
    graduationDegree: "",
    graduationCollege: "",
    graduationYear: "",
    graduationPercentage: "",
    // Post Graduation
    postGraduationDegree: "",
    postGraduationCollege: "",
    postGraduationYear: "",
    postGraduationPercentage: "",
    // Other
    certifications: "",
    experience: "",
    skills: [],
    cv: null,
    coverLetter: null,
  });

  // 40+ Skills List
  const skillsList = [
    "HTML", "CSS", "JavaScript", "React", "Angular", "Vue.js",
    "Node.js", "Express.js", "Next.js", "TypeScript",
    "Python", "Django", "Flask", "Java", "Spring Boot",
    "C++", "C#", ".NET", "PHP", "Laravel",
    "Ruby", "Ruby on Rails", "Go", "Kotlin", "Swift",
    "SQL", "MySQL", "PostgreSQL", "MongoDB", "Firebase",
    "AWS", "Azure", "Google Cloud", "DevOps", "Docker",
    "Kubernetes", "Jenkins", "CI/CD", "Git/GitHub", "Linux",
    "Cybersecurity", "Ethical Hacking", "Data Science", "Pandas",
    "NumPy", "Matplotlib", "TensorFlow", "PyTorch", "Machine Learning",
    "Deep Learning", "NLP", "Power BI", "Tableau"
  ];

  const [searchSkill, setSearchSkill] = useState("");

  const handleChange = (e) => {
    const { name, value, type, files } = e.target;
    setFormData({
      ...formData,
      [name]: type === "file" ? files[0] : value,
    });
  };

  const handleSkillChange = (skill) => {
    if (formData.skills.includes(skill)) {
      setFormData({
        ...formData,
        skills: formData.skills.filter((s) => s !== skill),
      });
    } else {
      setFormData({
        ...formData,
        skills: [...formData.skills, skill],
      });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form submitted:", formData);
    alert("✅ Your application has been submitted!");
  };

  return (
    <div
      style={{
        maxWidth: "800px",
        margin: "40px auto",
        padding: "30px",
        background: "#f9f9f9",
        borderRadius: "10px",
        boxShadow: "0 2px 12px rgba(0,0,0,0.2)",
      }}
    >
      <h2 style={{ textAlign: "center", marginBottom: "25px" }}>
        Job Application Form
      </h2>

      <form onSubmit={handleSubmit}>
        {/* Personal Details */}
        <label>Full Name *</label>
        <input
          type="text"
          name="fullName"
          value={formData.fullName}
          onChange={handleChange}
          required
          style={{ width: "100%", padding: "10px", marginBottom: "15px" }}
        />

        <label>Email *</label>
        <input
          type="email"
          name="email"
          value={formData.email}
          onChange={handleChange}
          required
          style={{ width: "100%", padding: "10px", marginBottom: "15px" }}
        />

        <label>Phone *</label>
        <input
          type="tel"
          name="phone"
          value={formData.phone}
          onChange={handleChange}
          required
          style={{ width: "100%", padding: "10px", marginBottom: "15px" }}
        />

        {/* Position */}
        <label>Position Applied For *</label>
        <select
          name="position"
          value={formData.position}
          onChange={handleChange}
          required
          style={{ width: "100%", padding: "10px", marginBottom: "20px" }}
        >
          <option value="">-- Select Position --</option>
          <option value="Frontend Developer">Frontend Developer</option>
          <option value="Backend Developer">Backend Developer</option>
          <option value="Full Stack Developer">Full Stack Developer</option>
          <option value="Cloud Engineer">Cloud Engineer</option>
          <option value="Data Analyst">Data Analyst</option>
          <option value="AI/ML Engineer">AI/ML Engineer</option>
          <option value="UI/UX Designer">UI/UX Designer</option>
          <option value="DevOps Engineer">DevOps Engineer</option>
          <option value="Cybersecurity Analyst">Cybersecurity Analyst</option>
          <option value="Intern - Web Development">Intern - Web Development</option>
          <option value="Intern - Data Science">Intern - Data Science</option>
          <option value="Intern - Cloud Computing">Intern - Cloud Computing</option>
          <option value="Intern - Cybersecurity">Intern - Cybersecurity</option>
          <option value="Intern - AI/ML">Intern - AI/ML</option>
          <option value="Training - Web Development">Training - Web Development</option>
          <option value="Training - Data Science">Training - Data Science</option>
          <option value="Training - Cloud">Training - Cloud</option>
          <option value="Training - Cybersecurity">Training - Cybersecurity</option>
        </select>

        {/* Education - 10th */}
        <h3>10th Details</h3>
        <label>Board *</label>
        <input
          type="text"
          name="tenthBoard"
          value={formData.tenthBoard}
          onChange={handleChange}
          required
          style={{ width: "100%", padding: "8px", marginBottom: "10px" }}
        />
        <label>Year *</label>
        <input
          type="number"
          name="tenthYear"
          value={formData.tenthYear}
          onChange={handleChange}
          required
          style={{ width: "100%", padding: "8px", marginBottom: "10px" }}
        />
        <label>Percentage/Grade *</label>
        <input
          type="text"
          name="tenthPercentage"
          value={formData.tenthPercentage}
          onChange={handleChange}
          required
          style={{ width: "100%", padding: "8px", marginBottom: "15px" }}
        />

        {/* Education - 12th */}
        <h3>12th Details</h3>
        <label>Board *</label>
        <input
          type="text"
          name="twelfthBoard"
          value={formData.twelfthBoard}
          onChange={handleChange}
          required
          style={{ width: "100%", padding: "8px", marginBottom: "10px" }}
        />
        <label>Year *</label>
        <input
          type="number"
          name="twelfthYear"
          value={formData.twelfthYear}
          onChange={handleChange}
          required
          style={{ width: "100%", padding: "8px", marginBottom: "10px" }}
        />
        <label>Percentage/Grade *</label>
        <input
          type="text"
          name="twelfthPercentage"
          value={formData.twelfthPercentage}
          onChange={handleChange}
          required
          style={{ width: "100%", padding: "8px", marginBottom: "15px" }}
        />

        {/* Graduation */}
        <h3>Graduation</h3>
        <label>Degree *</label>
        <input
          type="text"
          name="graduationDegree"
          value={formData.graduationDegree}
          onChange={handleChange}
          required
          style={{ width: "100%", padding: "8px", marginBottom: "10px" }}
        />
        <label>College *</label>
        <input
          type="text"
          name="graduationCollege"
          value={formData.graduationCollege}
          onChange={handleChange}
          required
          style={{ width: "100%", padding: "8px", marginBottom: "10px" }}
        />
        <label>Year *</label>
        <input
          type="number"
          name="graduationYear"
          value={formData.graduationYear}
          onChange={handleChange}
          required
          style={{ width: "100%", padding: "8px", marginBottom: "10px" }}
        />
        <label>Percentage/CGPA *</label>
        <input
          type="text"
          name="graduationPercentage"
          value={formData.graduationPercentage}
          onChange={handleChange}
          required
          style={{ width: "100%", padding: "8px", marginBottom: "15px" }}
        />

        {/* Post Graduation */}
        <h3>Post Graduation (if any)</h3>
        <label>Degree</label>
        <input
          type="text"
          name="postGraduationDegree"
          value={formData.postGraduationDegree}
          onChange={handleChange}
          style={{ width: "100%", padding: "8px", marginBottom: "10px" }}
        />
        <label>College</label>
        <input
          type="text"
          name="postGraduationCollege"
          value={formData.postGraduationCollege}
          onChange={handleChange}
          style={{ width: "100%", padding: "8px", marginBottom: "10px" }}
        />
        <label>Year</label>
        <input
          type="number"
          name="postGraduationYear"
          value={formData.postGraduationYear}
          onChange={handleChange}
          style={{ width: "100%", padding: "8px", marginBottom: "10px" }}
        />
        <label>Percentage/CGPA</label>
        <input
          type="text"
          name="postGraduationPercentage"
          value={formData.postGraduationPercentage}
          onChange={handleChange}
          style={{ width: "100%", padding: "8px", marginBottom: "15px" }}
        />

        {/* Certifications */}
        <h3>Certifications (if any)</h3>
        <textarea
          name="certifications"
          value={formData.certifications}
          onChange={handleChange}
          placeholder="List certifications, if any"
          style={{
            width: "100%",
            padding: "10px",
            marginBottom: "15px",
            minHeight: "60px",
          }}
        />

        {/* Experience */}
        <label>Work Experience (if any)</label>
        <textarea
          name="experience"
          value={formData.experience}
          onChange={handleChange}
          placeholder="Mention your past internships, training, or job experience"
          style={{ width: "100%", padding: "10px", marginBottom: "15px", minHeight: "80px" }}
        />

        {/* Skills */}
        <label>Skills *</label>
        <input
          type="text"
          placeholder="🔍 Search skills..."
          value={searchSkill}
          onChange={(e) => setSearchSkill(e.target.value)}
          style={{ width: "100%", padding: "10px", marginBottom: "10px" }}
        />

        <div
          style={{
            maxHeight: "150px",
            overflowY: "scroll",
            border: "1px solid #ccc",
            padding: "10px",
            marginBottom: "15px",
            background: "#fff",
          }}
        >
          {skillsList
            .filter((skill) =>
              skill.toLowerCase().includes(searchSkill.toLowerCase())
            )
            .map((skill) => (
              <div key={skill}>
                <input
                  type="checkbox"
                  checked={formData.skills.includes(skill)}
                  onChange={() => handleSkillChange(skill)}
                />
                <label style={{ marginLeft: "8px" }}>{skill}</label>
              </div>
            ))}
        </div>

        {/* CV Upload */}
        <label>Upload CV *</label>
        <input
          type="file"
          name="cv"
          accept=".pdf,.doc,.docx"
          onChange={handleChange}
          required
          style={{ width: "100%", marginBottom: "20px" }}
        />

        {/* Cover Letter Upload */}
        <label>Upload Cover Letter *</label>
        <input
          type="file"
          name="coverLetter"
          accept=".pdf,.doc,.docx"
          onChange={handleChange}
          required
          style={{ width: "100%", marginBottom: "20px" }}
        />

        <button
          type="submit"
          style={{
            background: "#28a745",
            color: "#fff",
            padding: "12px 20px",
            border: "none",
            borderRadius: "5px",
            cursor: "pointer",
            width: "100%",
          }}
        >
          Submit Application
        </button>
      </form>
    </div>
  );
}

export default Form;
